import { makeStyles } from 'tss-react/mui';

interface Props {
  isFeatured: boolean;
}

const useStyles = makeStyles<Props>({
  name: 'SpacingContainer',
})(({ spacing }, props) => ({
  container: {
    padding: `${spacing(props.isFeatured ? 5 : 3)} 0`,
  },
}));

export default useStyles;
